import { render } from "./ScoreboardNudgeModal.vue?vue&type=template&id=eb3cbcaa&scoped=true&ts=true"
import script from "./ScoreboardNudgeModal.vue?vue&type=script&lang=ts"
export * from "./ScoreboardNudgeModal.vue?vue&type=script&lang=ts"

import "./ScoreboardNudgeModal.vue?vue&type=style&index=0&id=eb3cbcaa&scoped=true&lang=css"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb3cbcaa"]])

export default __exports__